import { Lock, Crown } from "lucide-react";
import { usePro } from "../../hooks/usePro";

// Wraps a generated AI result. Pro users see it in full. Non-Pro users see a
// blurred teaser with an "Unlock with Pro" overlay (result is generated first,
// then locked — the "so close, unlock to see it" conversion moment).
export const ResultPaywall = ({ children, label = "results", testid = "result-paywall" }) => {
  const ctx = usePro();
  if (!ctx || ctx.isPro) return <>{children}</>;
  return (
    <div className="relative" data-testid={testid}>
      <div className="pointer-events-none select-none blur-[7px] max-h-[540px] overflow-hidden opacity-80" aria-hidden="true">
        {children}
      </div>
      <div className="absolute inset-0 flex items-start justify-center pt-16 bg-gradient-to-b from-white/50 via-white/80 to-white">
        <div className="text-center max-w-sm px-6">
          <span className="w-14 h-14 rounded-2xl bg-[#0F0F0F] text-[#D4AF37] flex items-center justify-center mx-auto">
            <Lock size={24} />
          </span>
          <h3 className="font-display text-xl font-extrabold text-[#0F0F0F] mt-4">Your {label} are ready 🎉</h3>
          <p className="text-sm text-[#687280] mt-2">
            Unlock the full {label} — plus every business idea, blueprint, report and download — with LaunchBS Pro.
          </p>
          <button
            onClick={() => ctx.openUpgrade("welcome")}
            className="mt-5 inline-flex items-center gap-2 bg-[#D4AF37] text-[#0F0F0F] rounded-full px-7 py-3 text-sm font-bold hover:bg-[#c5a030] transition-colors"
            data-testid={`${testid}-cta`}
          >
            <Crown size={16} /> Unlock with Pro
          </button>
        </div>
      </div>
    </div>
  );
};
